export enum ApplicationFilterStatusType {
	ALL = "All",
	CREATED = "Created",
	APPROVED = "Approved",
	DECLINED = "Declined"
}
